import { Route, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { ProfessionalComponent } from './professional.component';
import { JobNavigationGuard } from './guards/job-navigation.guard';
import { StyleMetasResolver } from './style-metas-resolver';
import {
  ServiceTypeMatcher,
  ProfessionalFilterMatcher, CityFilterMatcher,
} from './professional-filter-matcher';
import { StylesResolver } from './styles-resolver';
import { ServiceTypesResolver } from './service-types-resolver';
import { ServiceTypesMetasResolver } from './service-types-metas-resolver';
import { environment } from 'environments/environment';
import { CityMetasResolver } from 'src/app/modules/pro/professional/city-metas-resolver';

export const jobSlug = 'jobSlug';
export const proSlug = 'proSlug';
export const boxSlug = 'box';
export const decoOffersSlug = 'deco-offers';

export const cityRoutes = (job = null) => {
  return [
    {
      matcher: CityFilterMatcher,
      children: [
        {
          path: '',
          resolve: {
            citySlug: CityMetasResolver,
            styles: StyleMetasResolver
          },
          data: {
            breadcrumbRedirect: `/pro/{{citySlug}}`,
            breadcrumbKey: `kz-breadcrumb.pro.listing-city`,
            isBox: false,
            isDecoOffers: false,
            metas: {
              titleKey: `meta.pro.listing${job ? '-' + job : ''}-city.title`,
              descriptionKey: `meta.pro.listing${job ? '-' + job : ''}-city.description`,
              follow: {
                fr: 'index, follow',
                others: 'noindex, nofollow'
              }
            }
          },
          children: [
            {
              path: '',
              loadChildren: () => import('./pro-listing/pro-listing.module').then(m => m.ProListingModule),
            },
            ...styleRoutes(false, job, true)
          ]
        },
      ]
    }
  ]
}

export const styleRoutes = (isBox = false, job = null, city = null) => {
  return [
    {
      path: '',
      resolve: {
        styles: StylesResolver
      },
      loadChildren: () => import('./pro-listing/pro-listing.module').then(m => m.ProListingModule)
    },
    {
      matcher: ProfessionalFilterMatcher,
      children : [
        {
          path: '',
          data: {
            breadcrumbRedirect: `/pro${job ? '/' + job : ''}${city ? '/{{citySlug}}' : ''}/box/{{styleSlug}}`,
            breadcrumbKey: `kz-breadcrumb.pro.listing${job ? '-' + job : ''}-style`,
            isBox: isBox,
            isDecoOffers: false,
            metas: {
              titleKey: `meta.pro.listing${job ? '-' + job : ''}${isBox ? '-box' : ''}${city ? '-city' : ''}-style.title`,
              descriptionKey: `meta.pro.listing${job ? '-' + job : ''}${isBox ? '-box' : ''}${city ? '-city' : ''}-style.description`,
              follow: {
                fr: (isBox || job || city) ? 'noindex, nofollow': 'index, follow',
                others: 'noindex, nofollow'
              }
            }
          },
          resolve: {
            styles: StyleMetasResolver
          },
          loadChildren: () => import('./pro-listing/pro-listing.module').then(m => m.ProListingModule)
        },
      ]
    }
  ] as Array<Route>;
};

export const serviceTypeRoutes = (isBox = false) => {
  return [
    {
      path: '',
      resolve: {
        serviceTypes: ServiceTypesResolver
      },
      loadChildren: () => import('./pro-listing/pro-listing.module').then(m => m.ProListingModule)
    },
    {
      matcher: ServiceTypeMatcher,
      children : [
        {
          path: '',
          data: {
            breadcrumbRedirect: '/pro/box/{{serviceTypeSlug}}',
            breadcrumbKey: 'kz-breadcrumb.pro.listing-serviceType',
            isBox: isBox,
            isDecoOffers: true,
            metas: {
              titleKey: `meta.pro.listing-deco-offers${isBox ? '-box' : ''}-serviceType.title`,
              descriptionKey: `meta.pro.listing-deco-offers${isBox ? '-box' : ''}-serviceType.description`,
              follow: {
                fr: (isBox) ? 'index, follow' : 'index, follow',
                others: 'noindex, nofollow'
              }
            }
          },
          resolve: {
            serviceTypes: ServiceTypesMetasResolver
          },
          loadChildren: () => import('./pro-listing/pro-listing.module').then(m => m.ProListingModule)
        },
      ]
    }
  ] as Array<Route>;
};

export const routes: Routes = [
  {
    path: 'decoration',
    // loadChildren: () => import('./landing/decoration/landing-decoration.module').then(m => m.LandingDecorationModule)
    redirectTo: '/pro',
  },
  {
    path: 'find-a-professional',
    // loadChildren: () => import('./landing/find-a-professional/find-a-professional.module').then(m => m.FindAProfessionalModule),
    redirectTo: '/pro',
    data: {
      breadcrumbRedirect: 'pro',
      breadcrumbKey: 'kz-breadcrumb.pro.listing',
    }
  },
  {
    path: '',
    component: ProfessionalComponent,
    data: {
      breadcrumbRedirect: 'pro',
      breadcrumbKey: 'kz-breadcrumb.pro.listing',
      metas: {
        titleKey: 'meta.pro.listing.title',
        descriptionKey: 'meta.pro.listing.description',
        follow: {
          fr: 'index, follow',
          others: 'noindex, nofollow'
        }
      }
    },
    children: [
      {
        path: `${boxSlug}`,
        component: ProfessionalComponent,
        data: {
          breadcrumbRedirect: 'box',
          breadcrumbKey: 'kz-breadcrumb.pro.listing-box',
          isBox: true,
          metas: {
            titleKey: 'meta.pro.listing-box.title',
            descriptionKey: 'meta.pro.listing-box.description',
            follow: {
              fr: 'index, follow',
              others: 'noindex, nofollow'
            }
          }},
        children: styleRoutes(true)
      },
      {
        path: `${decoOffersSlug}`,
        component: ProfessionalComponent,
        data: {
          breadcrumbRedirect: 'deco-offers',
          breadcrumbKey: 'kz-breadcrumb.pro.listing-deco-offers',
          isBox: false,
          isDecoOffers: true,
          metas: {
            titleKey: 'meta.pro.listing-deco-offers.title',
            descriptionKey: 'meta.pro.listing-deco-offers.description',
            follow: {
              fr: 'index, follow',
              others: 'noindex, nofollow'
            }
          }},
        children: [
          {
            path: `${boxSlug}`,
            component: ProfessionalComponent,
            data: {
              breadcrumbRedirect: 'box',
              breadcrumbKey: 'kz-breadcrumb.pro.listing-box',
              isBox: true,
              isDecoOffers: true,
              metas: {
                titleKey: 'meta.pro.listing-deco-offers-box.title',
                descriptionKey: 'meta.pro.listing-deco-offers-box.description',
                follow: {
                  fr: 'index, follow',
                  others: 'noindex, nofollow'
                }
              }},
            children: serviceTypeRoutes(true)
          },
          ...serviceTypeRoutes(false)
        ]
      },
      {
        path: 'interior-decorator',
        component: ProfessionalComponent,
        data: {
          breadcrumbRedirect: 'interior-decorator',
          breadcrumbKey: 'kz-breadcrumb.pro.listing-interior-decorator',
          isBox: false,
          metas: {
            titleKey: 'meta.pro.listing-interior-decorator.title',
            descriptionKey: 'meta.pro.listing-interior-decorator.description',
            follow: {
              fr: 'index, follow',
              others: 'noindex, nofollow'
            }
          },
          job: environment.PRO.DECORATOR_JOB
        },
        children: [
          ...cityRoutes('interior-decorator'),
          ...styleRoutes(false, 'interior-decorator')
        ]
      },
      {
        path: 'interior-architect',
        component: ProfessionalComponent,
        data: {
          breadcrumbRedirect: 'interior-architect',
          breadcrumbKey: 'kz-breadcrumb.pro.listing-interior-architect',
          isBox: false,
          metas: {
            titleKey: 'meta.pro.listing-interior-architect.title',
            descriptionKey: 'meta.pro.listing-interior-architect.description',
            follow: {
              fr: 'index, follow',
              others: 'noindex, nofollow'
            }
          },
          job: environment.PRO.ARCHITECT_JOB
        },
        children: [
          ...cityRoutes('interior-architect'),
          ...styleRoutes(false, 'interior-architect')
        ]
      },
      ...cityRoutes(),
      ...styleRoutes()
    ]
  },
  {
    path: `:${jobSlug}`,
    component: ProfessionalComponent,
    data: {
      isFullHeader: true,
      breadcrumbKey: 'kz-breadcrumb.pro.listing',
      breadcrumbRedirect: 'pro',
    },
    canActivate: [JobNavigationGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/not_found',
      },
      {
        path: '',
        data: {
          breadcrumbKey: 'kz-breadcrumb.pro.listing',
          breadcrumbRedirect: 'pro',
        },
        loadChildren: () => import('./pro-profile/pro-profile.module').then(m => m.ProProfileModule)
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
    LocalizeRouterModule
  ]
})
export class ProfessionalRoutingModule {
}
